import React from 'react'
import BasicsEditor from './BasicsEditor'
import SummaryEditor from './SummaryEditor'
import EmploymentEditor from './EmploymentEditor'
import EducationEditor from './EducationEditor'
import SkillsEditor from './SkillsEditor'
import VolunteerEditor from './VolunteerEditor'
import { Switch } from '~/lib/ui/switch'
import { useTemplate } from '~/lib/pdf/TemplateProvider'
import AwardsEditor from './AwardsEditor'
import AdditionalInformationEditor from './AdditionalInformationEditor'
import ImportDialog from '../ImportDialog'
import { useTranslation } from '~/hooks/useTranslation'

const Editor = () => {
  const { showAllEditorFields, setShowAllEditorFields } = useTemplate()
  const { t } = useTranslation('Editor')

  return (
    <div className="-mt-6">
      <div className="mb-3 flex w-full flex-col gap-y-2 md:flex-row md:items-center md:justify-between">
        <div>
          {t('already_have_import_resume')}{' '}
          <ImportDialog>{t('import_resume')}</ImportDialog>
        </div>
        <div className="flex items-center whitespace-nowrap pl-4 max-md:justify-end">
          {/* CTS-9213 — button-name: switch has no accessible name; aria-label associates it with adjacent span text */}
          <span className="mr-2 whitespace-nowrap" id="show-all-fields-label">
            {t('show_all_fields')}
          </span>
          <Switch
            aria-labelledby="show-all-fields-label"
            checked={showAllEditorFields}
            onCheckedChange={setShowAllEditorFields}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-14">
        <BasicsEditor />
        <SummaryEditor />
        <EmploymentEditor />
        <EducationEditor />
        <VolunteerEditor />
        <SkillsEditor />
        <AwardsEditor />
        <AdditionalInformationEditor />
        <div className="md:h-80"></div>
      </div>
    </div>
  )
}
export default Editor
